export type PrintOnDemandHeaderProps = {
  onClose: (button: HTMLButtonElement | null) => void;
  isEditor?: boolean;
  onReturnToHomePage: () => void;
  isUK?: boolean;
};

export enum HeaderVariants {
  US = 'us',
  CE = 'ce',
}
